import { render, staticRenderFns } from "./userBehaviorSequence.vue?vue&type=template&id=0bbb0c5b&scoped=true&"
import script from "./userBehaviorSequence.vue?vue&type=script&lang=js&"
export * from "./userBehaviorSequence.vue?vue&type=script&lang=js&"
import style0 from "./userBehaviorSequence.vue?vue&type=style&index=0&id=0bbb0c5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb0c5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbb0c5b')) {
      api.createRecord('0bbb0c5b', component.options)
    } else {
      api.reload('0bbb0c5b', component.options)
    }
    module.hot.accept("./userBehaviorSequence.vue?vue&type=template&id=0bbb0c5b&scoped=true&", function () {
      api.rerender('0bbb0c5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/userBehaviorSequence.vue"
export default component.exports